import React from 'react';
import Logo from '../logo';
import './header.scss'
import Button from '../button';

const Header = (props) => {
  console.log('props', props);
  return(
    <div className="header">
      <Logo />
      <span><Button id="logout-btn" onClick={() => props.logout()} type="submit" text={'Logout'} /></span>
    </div>
  );
}
 

export default Header;
